import * as React from "react"
import styled from 'styled-components/macro'
import TitleSection from "./TitleSection";
import BlueChipSection from "./BlueChipSection";
import LowFeeSection from "./LowFeeSection";
import MobileSection from "./MobileSection";
import EarnMoreSection from "./EarnMoreSection";
import BorrowSection from "./BorrowSection";
import MoreAssetsSection from "./MoreAssetsSection";
import FutureSection from "./FutureSection";
import GetStartedSection from "./GetStartedSection";
import WhitepaperSection from "./WhitepaperSection";
import ComingSoon from "./ComingSoon";
import ComposableSection from "./ComposableSection";
import LeveragedFarmingSection from "./LeveragedFarmingSection";
import AuditedSection from "./AuditedSection";
import PartnersInvestorsIntegrationsSection from "./PartnersInvestorsIntegrationsSection";
import BottomAngle from "../../common/BottomAngle";
import TopAngle from "../../common/TopAngle";
import SecondaryTitleSection from "./SecondaryTitleSection";

const HomePageWrapper = styled.div`
  width: 100%;
`

const Spacer = styled.div`
  height: 100px;
  width: 100%;
  background: rgba(30,28,41,1);
  /*background: linear-gradient(0deg,rgba(30,28,41,1) 15%,rgba(30,28,41,0) 100%);*/
  background: linear-gradient(0deg,rgba(24, 24, 42, 1) 15%,rgba(24, 24, 42, 0) 100%);
  position: absolute;
  z-index: 1;
  
  /*@media screen and (max-width: 880px) {
    background: linear-gradient(0deg,rgba(24,24,42,1) 15%,rgb(12 12 17) 100%);
  }*/
`

const TwoItemRow = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 100px;
  position: relative;
`

//Footer

// markup
const HomePage = () => {
  return (
    <HomePageWrapper>
      {/*<ComingSoon />*/}
      <TitleSection />
      <Spacer>
        <BottomAngle />
      </Spacer>
      <BlueChipSection />
      <EarnMoreSection />
      <LeveragedFarmingSection />
      <BorrowSection />
      <MoreAssetsSection />
      <MobileSection />
      <ComposableSection />
      <TwoItemRow>
        <TopAngle />
        {/*<LowFeeSection />*/}
        <AuditedSection />
      </TwoItemRow>
      <PartnersInvestorsIntegrationsSection />
      <GetStartedSection />
      <FutureSection />
      <WhitepaperSection />
    </HomePageWrapper>
  )
}

export default HomePage
